export enum PurchaseEarnBetSteps {
  CONFIRM_DEPOSIT = 1,
  SELECT_PAYMENT = 2,
  ORDER_CONFIRMATION = 3
}
